import React from 'react';
import { PayrollProcessProvider } from '../../RemunerationProcesses/context/PayrollProcessProvider';
import ReliquidationProcessShow from './ReliquidationProcessShow';

const ReliquidationProcessEdit = props => {
  return (
    <PayrollProcessProvider>
      <ReliquidationProcessShow {...props} />
    </PayrollProcessProvider>
  );
};

export default ReliquidationProcessEdit;
